import robotSvg from '../assets/robot.svg';

const Background = () => {
    return (
        <div className="background">
            <div className="background-wrapper">
                <img
                    src={robotSvg}
                    alt="Robot Blueprint"
                    className="robot-svg"
                />
            </div>
        </div>
    );
};

export default Background; 